var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWritingClassHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8645 1.24836C11.1105 1.00488 11.6556 0.512111 12.0034 0.512111C12.1369 0.511917 12.0034 0.484937 12.4221 0.512144L13.459 1.54212C13.7049 1.78568 13.9796 1.93228 13.9796 2.27666C13.4604 2.79081 13.7063 2.54726 13.4604 2.79081L12.4221 3.81911L10.3454 1.76251L10.8645 1.24836ZM9.82619 2.27666L5.6728 5.87572C5.6728 5.87572 5.6728 5.87572 5.15363 6.38987L4.9346 7.65541C4.9346 7.99987 4.68852 8.56491 4.93447 8.80848C5.18042 9.05204 5.89824 8.95418 6.24606 8.95418L7.23032 8.96062C7.23032 8.96062 7.50361 8.69005 7.7495 8.44647L11.9029 4.33326L10.3454 2.79081L9.82619 2.27666Z",
    fill: "#555555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96718 8.30518H2.31145C1.96363 8.30518 1.63006 8.44201 1.38412 8.68558C1.13817 8.92914 1 9.25949 1 9.60394C1 9.94839 1.13817 10.2787 1.38412 10.5223C1.63006 10.7659 1.96363 10.9027 2.31145 10.9027H11.4916C11.8394 10.9027 12.173 11.0395 12.419 11.2831C12.6649 11.5267 12.8031 11.857 12.8031 12.2015C12.8031 12.5459 12.6649 12.8763 12.419 13.1198C12.173 13.3634 11.8394 13.5002 11.4916 13.5002H8.86872",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWritingClassHome);
export default __webpack_public_path__ + "static/media/WritingClassHome.de85654669fcf4dad10ebe2e953a96ad.svg";
export { ForwardRef as ReactComponent };